import { render } from "./DetailUserLocation.vue?vue&type=template&id=3b754b1a&scoped=true&ts=true"
import script from "./DetailUserLocation.vue?vue&type=script&lang=ts"
export * from "./DetailUserLocation.vue?vue&type=script&lang=ts"

import "./DetailUserLocation.vue?vue&type=style&index=0&id=3b754b1a&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3b754b1a"]])

export default __exports__